import React from "react";

// External package
import { TypeAnimation } from "react-type-animation";
import { useSelector } from "react-redux";

import style from "./home.module.scss";
import {
  imagesProfileData,
  imagesGalleryData,
  portofolioData,
} from "../../source/data";
import { RootState } from "../../store/authStore";
import { BALE_THEME_URL } from "../../source/links";
import { useTranslation } from "../../i18n";


const Home = () => {
  const imagesProfile = imagesProfileData;
  const imagesGallery = imagesGalleryData;
  const isMobile = useSelector((state: RootState) => state.auth.isMobile);
  const { t, lang } = useTranslation();

  return (
    <div>
      <div className={`home `}>
        <div className={`header-content mb-5`}>
          <div className="row">
            <div className="col-md-12 d-flex">
              <h1
                className={`font-vietnam-600 text-uppercase ${
                  isMobile ? "font-size-50 w-100 mb-0" : "font-size-160"
                }`}
              >
                creative
              </h1>
              {!isMobile && (
                <img
                  data-aos="zoom-in"
                  data-aos-duration="1000"
                  data-aos-easing="linear"
                  src={imagesProfile}
                  className={`${style.images_profile} ms-auto`}
                  alt={t.home.profileAlt}
                />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div
                className={`${isMobile ? "row" : "d-flex justify-content-end"}`}
              >
                <h2
                  className={`font-vietnam-100-italic text-uppercase ${
                    isMobile ? "font-size-50 col-12 mb-0" : "font-size-100"
                  }`}
                >
                  developer
                </h2>
                <h2
                  className={`font-vietnam-600 text-uppercase ${
                    isMobile ? "font-size-50 col-12" : "font-size-100"
                  }`}
                >
                  &nbsp; portfolio
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 d-flex align-items-center">
              <div className="me-auto">
                <p
                  className={`mb-0 pb-0 font-vietnam-700 text-uppercase font-white-7 ${
                    isMobile ? "font-size-14" : ""
                  }`}
                >
                  {t.home.buildingDigital[0]}
                </p>
                <p
                  className={`mb-0 pb-0 font-vietnam-700 text-uppercase font-white-7 ${
                    isMobile ? "font-size-14" : ""
                  }`}
                >
                  {t.home.buildingDigital[1]}
                </p>
              </div>
              <h2
                className={`font-vietnam-600-italic  text-uppercase ${
                  isMobile ? "font-size-30" : "font-size-160"
                }`}
              >
                - 2020
              </h2>
            </div>
          </div>
        </div>
        <div className={`gallery-content mb-5`}>
          <div className="row">
            {imagesGallery.map((image, index) => {
              let imgWidth = 150;
              let imgHeight = 200;

              if (index === 2) {
                imgWidth = 300;
                imgHeight = 500;
              } else if (index === 5 || index === 6) {
                imgWidth = 200;
                imgHeight = 200;
              }

              return (
                <div
                  data-aos="zoom-out"
                  data-aos-duration="800"
                  data-aos-delay={index * 150}
                  className={`${
                    isMobile
                      ? "col-sm-6"
                      : index === 2
                      ? "col-md-3"
                      : style.col_md_2_custom
                  } ${
                    !isMobile && (index === 3 || index === 4)
                      ? style.position_bottom
                      : ""
                  }`}
                  key={image.id}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    width={imgWidth}
                    height={imgHeight}
                    loading="lazy"
                    className={style.gallery_image}
                  />
                  <figcaption className="d-flex justify-content-between font-size-14 mt-1">
                    <span className="font-vietnam-200">0{index + 1}</span>
                    <span className="font-vietnam-500">
                      {image.description[lang]}
                    </span>
                  </figcaption>
                </div>
              );
            })}
          </div>
        </div>
        <div className={`motivation-content mb-5 ${isMobile ? "" : "pt-4"}`}>
          <div className="row">
            <div
              className={`col-md-12 ${
                isMobile ? "" : "d-flex align-items-start"
              }`}
            >
              <div className="me-auto">
                <p className="mb-0 pb-0 font-vietnam-700 text-uppercase font-white-7">
                  {t.home.craftingInnovative[0]}
                </p>
                <p className="mb-0 pb-0 font-vietnam-700 text-uppercase font-white-7">
                  {t.home.craftingInnovative[1]}
                </p>
              </div>
              <div className={`${isMobile ? "mt-3" : ""}`}>
                <TypeAnimation
                  key={lang}
                  sequence={[
                    t.home.typing[0],
                    1000,
                    t.home.typing[1],
                    2000,
                    t.home.typing[2],
                    3000,
                  ]}
                  wrapper="h2"
                  cursor={true}
                  repeat={Infinity}
                  className={`font-vietnam-200-italic text-uppercase`}
                />
                <h2
                  className={`font-vietnam-500 text-uppercase ${
                    isMobile ? "font-size-14" : "font-size-36"
                  }`}
                >
                  {t.home.quoteBody[0]}
                </h2>
                <h2
                  className={`font-vietnam-500 text-uppercase ${
                    isMobile ? "font-size-14" : "font-size-36"
                  }`}
                >
                  {t.home.quoteBody[1]}{" "}
                </h2>
                <h2
                  className={`font-vietnam-500 text-uppercase ${
                    isMobile ? "font-size-14" : "font-size-36"
                  }`}
                >
                  {t.home.quoteBody[2]}
                </h2>
                <h2
                  className={`font-vietnam-200-italic text-uppercase ${
                    isMobile ? "font-size-14" : "font-size-36"
                  }`}
                >
                  {t.home.quoteFail[0]}
                </h2>{" "}
                <h2
                  className={`font-vietnam-200-italic text-uppercase ${
                    isMobile ? "font-size-14" : "font-size-36"
                  }`}
                >
                  {t.home.quoteFail[1]} <span>-</span>{" "}
                  <span
                    className={`font-vietnam-500 font-white-9 text-uppercase ${
                      isMobile ? "font-size-14" : "font-size-36"
                    }`}
                  >
                    {t.home.quoteAuthor}
                  </span>
                </h2>{" "}
              </div>
            </div>
          </div>
        </div>
        <div className={`service-content mb-5 ${isMobile ? "" : "pt-5"}`}>
          <div className="row mb-5">
            <div className="col-md-12 d-flex">
              <div>
                <h2 className="font-vietnam-500 font-size-20 text-uppercase">
                  {t.home.serviceIntro[0]}
                </h2>
                <h2 className="font-vietnam-200-italic font-size-20 text-uppercase">
                  {t.home.serviceIntro[1]}
                </h2>
                <h2 className="font-vietnam-500 font-size-20 text-uppercase">
                  {t.home.serviceIntro[2]}
                </h2>
              </div>
              <div className="ms-auto mb-0 pb-0 font-vietnam-700 text-uppercase font-white-7">
                <p className="mb-0 pb-0">{t.home.qualityCode} </p>
                <p className="mb-0 pb-0">
                  {t.home.qualityFor}{" "}
                  <span className="font-vietnam-300-italic font-white-6">
                    {t.home.qualityProject}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {t.home.serviceLines.map((service) => (
                <div
                  key={service.label}
                  className={`services px-4 border-top border-bottom py-3 d-flex justify-content-between align-items-center text-uppercase font-vietnam-500 fw-bold ${
                    isMobile ? "font-size-24" : "font-size-36"
                  }`}
                >
                  <span>{service.label}</span>
                  <div className="count-project text-end">
                    <span className="font-vietnam-500 font-size-18 lh-1">
                      {service.stack}
                    </span>
                    <p className="font-vietnam-500-italic mb-0 pb-0 font-size-14 text-capitalize">
                      {service.note}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={"portofolio-content mb-5 pt-5"}>
          <div className="row">
            <div className="col-md-6">
              <div className="portofolio-content_text text-center mb-4">
                <p className="font-vietnam-500 font-size-28">{"</>"}</p>
                <p className="mb-0 pb-0 font-vietnam-500 font-size-28 text-capitalize lh-1">
                  {t.home.explore[0]}
                </p>
                <p className="mb-0 pb-0 font-vietnam-500 font-size-28 text-capitalize">
                  {t.home.explore[1]}
                </p>
              </div>
              <div className="text-center">
                <p className="mb-0 pb-0 font-vietnam-700 text-uppercase font-white-7">
                  {t.home.showcasing[0]}
                </p>
                <p className="mb-0 pb-0 font-vietnam-700 text-uppercase font-white-7">
                  {t.home.showcasing[1]}
                </p>
              </div>
              <div className="text-center mt-2">
                <a
                  href={BALE_THEME_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-vietnam-700 text-uppercase font-white-6 see-more"
                >
                  {t.home.seeMore}
                </a>
              </div>
            </div>
            {portofolioData.map((item, index) => (
              <div
                key={item.id}
                data-aos="fade-up"
                data-aos-anchor-placement="top-center"
                data-aos-duration="800"
                data-aos-delay={index * 100}
                className={`col-md-3 mt-${index > 1 ? 3 : 0}`}
              >
                <div
                  className={`portofolio-content_picture ${
                    item.label ? "border rounded" : ""
                  }`}
                >
                  {item.src && (
                    <img
                      src={item.src}
                      alt={item.alt}
                      loading="lazy"
                      style={{ width: "100%" }}
                    />
                  )}
                </div>
                {item.label && (
                  <figcaption className="d-flex justify-content-between font-size-14 mt-1">
                    <span className="font-vietnam-200">{item.value}</span>
                    <span className="font-vietnam-500"> {item.label[lang]}</span>
                  </figcaption>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className={"tagline-content mb-5 pt-5"}>
          <h2 className="font-white-9 font-vietnam-600 text-uppercase">
            {t.home.tagline[0]}{" "}
          </h2>
          <h2 className="font-vietnam-100-italic">{t.home.tagline[1]} </h2>
          <h2 className="font-black-1 font-vietnam-900 fw-bold">
            {t.home.tagline[2]}
          </h2>
        </div>
      </div>
    </div>
  );
};

export default Home;
